module.exports = __webpack_public_path__ + "static/Slide1-0b6ea6b44211c7295b258db6438bb338.jpg";